<div class="give-access"
     (click)="overlayPanel.toggle($event)"
>
  <p class="give-access__title">Give access</p>
  <div class="give-access__button">
    <app-icon-feather
      class="icon"
      icon="x"
      width="15"
      height="15"
      fill="#2A2A2A"
    ></app-icon-feather>
    <p-overlayPanel #overlayPanel
                    appendTo="body"
                    [style]="{ width: '245px' }"
                    (onHide)="form.reset()"
    >
      <ng-template pTemplate>
        <form class="row"
              novalidate
              [formGroup]="form"
        >
          <div class="col-12 mb-4">
            <div class="p-field">
              <div class="p-field__title">
                <label class="text--sm" for="input-email">Email address</label>
              </div>
              <input id="input-email"
                     type="text"
                     pInputText
                     placeholder="test@gmail.com"
                     name="username"
                     class="fw-500 md"
                     [formControl]="userName"
              >
              <div class="position-relative">
                <small class="p-error"
                       *ngIf="userName.dirty && userName.invalid"
                >
                  {{ getErrorMessage('Email', userName) }}
                </small>
              </div>
            </div>
          </div>

          <div class="col-12" [formGroup]="permissions">
            <div class="p-field-checkbox p-field-checkbox--sm text-left d-flex align-items-center mb-2">
              <p-checkbox inputId="view" binary="true" formControlName="view"></p-checkbox>
              <label class="text--sm p-checkbox-label" for="view">View</label>
            </div>
            <div class="p-field-checkbox p-field-checkbox--sm text-left d-flex align-items-center mb-2">
              <p-checkbox inputId="share" binary="true" formControlName="share"></p-checkbox>
              <label class="text--sm p-checkbox-label" for="share">Share</label>
            </div>
            <div class="p-field-checkbox p-field-checkbox--sm text-left d-flex align-items-center mb-2">
              <p-checkbox inputId="edit" binary="true" formControlName="edit"></p-checkbox>
              <label class="text--sm p-checkbox-label" for="edit">Edit</label>
            </div>
          </div>

          <div class="col-12 mt-4">
            <button pButton
                    class="w-100"
                    type="submit"
                    label="ADD ACCESS"
                    [disabled]="form.invalid"
                    (click)="submit(); overlayPanel.hide()"
            ></button>
          </div>
        </form>
      </ng-template>
    </p-overlayPanel>
  </div>
</div>

